module.exports = __webpack_public_path__ + "img/ic-close.46f5345e.svg";